export default __webpack_public_path__ + "static/airbnb-11-36556f10f7869458a8685652c9f22cf3.png";